<template>
  <div class="flex flex-row w-screen h-screen relative bg-gray-50">
    <BaseSidebar />
    <div class="h-full w-full flex flex-col flex-1 overflow-y-scroll">
      <div class="sticky top-0 z-10 bg-gray-50 border-b w-full flex p-4 justify-between">
        <div class="flex gap-x-1">
          <span
            class="flex items-center cursor-pointer"
            @click="navigateTo({ name: 'contracts' })"
          >
            Contracts
          </span>

          <span
            v-if="contract"
            class="flex items-center"
          >
            <Icon name="ic:baseline-keyboard-arrow-right" />
          </span>
          <span
            v-if="contract"
            class="flex items-center text-primary-500 font-bold"
          >
            {{ contract.Business.name }}
          </span>
        </div>

        <div
          v-if="!isAuditor"
          class="flex gap-2"
        >
          <NoteCreate
            :contactId="contractOwner?.contactId"
            :businessId="contract?.Business.id"
            :contractId="contract?.id"
            @refresh="eventBus.emit('refresh-timeline')"
          />

          <ContractAddFile
            v-model:contract="contract"
            @refresh="eventBus.emit('refresh-contract')"
          />
        </div>
      </div>

      <div
        class="flex flex-row w-full h-screen h-full overflow-y-hidden"
      >
        <ContractSidebar />
        <div class="h-full w-full flex flex-col flex-1 bg-gray-100 overflow-y-auto">
          <div class="p-6 rounded-md contentContainer">
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { Contract } from '~/types/contracts'
import { useEventBus } from '@vueuse/core'
import type { ContractContact } from '@prisma/client'

const eventBus = useEventBus<'refresh-timeline' | 'refresh-contract'>('contract-events')
const { isAuditor } = useRolePermissions()

const route = useRoute()
const { getContractById } = useContracts()

const isLoading = ref(true)
const contractId = computed(() => route.params.id as string)

const contract = ref<Contract | null>(null)
const contractOwner = ref<ContractContact | null>()

onMounted(async () => {
  await loadContract()
})

const loadContract = async () => {
  isLoading.value = true

  try {
    if (!contractId.value) {
      return
    }

    const { data, error } = await getContractById(contractId.value)

    if (data) {
      contract.value = data
    }

    if (!contract.value) {
      contractOwner.value = null
      return
    }

    const ownersList = contract.value.ContractContacts?.filter(contact => contact.role === 'OWNER')

    if (!ownersList || ownersList.length === 0) {
      contractOwner.value = null
      return
    }

    contractOwner.value = ownersList[0]
  }
  catch (error) {
    console.error('Error loading contract:', error)
    contract.value = null
  }
  finally {
    isLoading.value = false
  }
}
</script>
